import { render } from "./Document.vue?vue&type=template&id=58539830&lang=pug"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"
script.render = render

export default script